import { defineStore } from 'pinia'

export const useInterfaceStore = defineStore('interface', {
  state: () => ({ 
    teal: false,
    multiverse: false,
  }),
  actions: {
  },
})
